// extracted by mini-css-extract-plugin
export default {"root":"ZK4sUPhu93SYk9X8vzYT","labelText":"VNtHaL4dxhUiCGqicTWV","valueText":"TWoEEOUrZmmXdkpAoREv"};